import React from 'react';
import PropTypes from 'prop-types';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ListItemLink from 'components/Common/ListItemLink/ListItemLink';

const SpecPagesAllTags = props => {
  if (!props.specialPagesTags) {
    return null;
  }
  return (
    <div className="container">
      <ul className="nav nav-tabs nav-tabs_muted nav-tabs_no-border nav-tabs-lg hidden-xs text-center">
        <ListItemLink to={`/spec/all`}>
          <i className="fa fa-home" />
        </ListItemLink>
        {props.specialPagesTags.map(item => (
          <ListItemLink
            key={`specPagesAllTags${item.id}`}
            to={`/spec/tag/${item.seo_url}`}
          >
            {item.title}
          </ListItemLink>
        ))}
      </ul>
    </div>
  );
};

SpecPagesAllTags.propTypes = {
  // CONNECT STATES
  specialPagesTags: PropTypes.arrayOf(PropTypes.shape).isRequired
};

const mapStateToProps = state => ({
  specialPagesTags: getItemFromRefList(state, 'specialPagesTags')
});

export default withRouter(connect(mapStateToProps)(SpecPagesAllTags));



// WEBPACK FOOTER //
// ./src/components/SpecialPages/Common/SpecPagesAllTags/SpecPagesAllTags.js